export default __webpack_public_path__ + "double-arrow-down.svg";